module.exports = __webpack_public_path__ + "screenshot.b949874ccf086480260a7c424ece4a57.png";